import React, { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  DownloadMultipleClientsDataInExcel,
  getEndOfMonth,
  getStartOfMonth,
  getStartOfPrevious11Months,
} from "../Shared/Utility";
import { useGlobalState } from "../Context/GlobalStateContext";
import ConfirmationModal from "../App/ConfirmationModal";
import MultiSelectionDropdown from "../App/MultiSelectionDropdown";
import { showErrorMessage } from "../Shared/Toast";
function DamageClaims() {
  const globalState = useGlobalState();
  const [showModal, setShowModal] = useState(false);
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [DamageClaimGetHistoricalData, setDamageClaimGetHistoricalDataion] =
    useState<any>([]);

  const [sourceList, setSourceList] = useState<any>([]);

  const [DamageClaimMoversList, setDamageClaimMoversList] = useState<any>([]);

  const [damageClaimObject, setDamageClaimObject] = useState({
    mnvclientid: 0,
    mnvmoverid: AppContext.MNVMoverID,
    jobid: "",
    name: "All",
    startdate: getStartOfPrevious11Months(),
    enddate: getEndOfMonth(),
  });

  const [addEditObject, setAddEditObject] = useState<any>({
    name: "",
    jobid: "",
    servicedate: new Date(),
    claimdate: new Date(),
    description: "",
    mnvclientid: 0,
    damagedoneby: 0,
    outcome: "",
    cost: "",
    insuranceclaimref: "",
    moverslist: "",
    extratextfield1: "",
    extratextfield2: "",
    notifymover: 0,
  });

  const [reviewSourceTypeList, setReviewSourceTypeList] = useState<any>([]);
  const [reviewSourceTypeListCustom, setReviewSourceTypeListCustom] =
    useState<any>([]);
  const [moversList, setMoversList] = useState([]);
  const [selectedSourceObject, setSelectedSourceObject] = useState<any>({});

  useEffect(() => {
    setDamageClaimObject((prevState: any) => ({
      ...prevState,
      startdate: getStartOfPrevious11Months(),
      enddate: getEndOfMonth(),
    }));
    getDamageClaimGetJobDetailsAndMoversList(1);
    getDamageClaimGetHistoricalData();
  }, []);

  useEffect(() => {
    if (isAddNew == 2 && addEditObject.jobid != "")
      getDamageClaimGetJobDetailsAndMoversList(4);
  }, [isAddNew, addEditObject.jobid]);

  function getDamageClaimGetJobDetailsAndMoversList(typeid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.typeid = typeid;
    object.jobid = addEditObject.jobid;
    object.screenname = "damageclaims";
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVJobReview/MNVJobReviewGetJobDetailsAndMoversList",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (typeid == 3 || typeid == 4) {
            if (
              l_response.length > 0 &&
              l_response[0].length > 0 &&
              addEditObject.jobid != ""
            ) {
              let reviewdate = new Date();
              if (typeid == 3) {
                if (l_response[0] && l_response[0][0]) {
                  reviewdate = new Date(l_response[0][0].RequestedDate);
                }

                setAddEditObject((prevState: any) => ({
                  ...prevState,
                  servicedate: reviewdate,
                }));
              }
              setDamageClaimMoversList(l_response[1]);
            } else {
              setAddEditObject((prevState: any) => ({
                ...prevState,
                servicedate: "",
              }));

              showErrorMessage("It looks like a duplicate entry!");
            }
          }

          if (typeid == 1) {
            setReviewSourceTypeList(l_response[0]);
            setMoversList(l_response[1]);
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getDamageClaimGetHistoricalData() {
    setIsAnimation(true);
    let object = {} as any;
    object.damagedoneby = 1;
    object.mnvclientid = damageClaimObject.mnvclientid;
    object.mnvmoverid = damageClaimObject.mnvmoverid;
    object.jobid = damageClaimObject.jobid;
    object.name = damageClaimObject.name;
    object.startdate = damageClaimObject.startdate;
    object.enddate = damageClaimObject.enddate;
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVDamageClaim/MNVDamageClaimGetHistoricalDataV2",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setDamageClaimGetHistoricalDataion(l_response[0]);
          setSourceList(l_response[1]);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation() {
    let isValid = true;
    if (addEditObject.name == "") {
      isValid = false;

      showErrorMessage("Type Required");
    } else if (addEditObject.jobid == "") {
      isValid = false;

      showErrorMessage("Job ID Required");
    } else if (addEditObject.servicedate == "") {
      isValid = false;

      showErrorMessage("Service Date Required");
    } else if (addEditObject.claimdate == "") {
      isValid = false;

      showErrorMessage("Claim Date Required");
    } else if (addEditObject.description == "") {
      isValid = false;
      showErrorMessage("Description Required");
    } else if (
      DamageClaimMoversList.length == 0 ||
      DamageClaimMoversList[0].length == 0
    ) {
      isValid = false;
      showErrorMessage("Mover(s) Required");
    }

    if (isValid == true) {
      if (isAddNew == 1) {
        damageClaimSaveCustom();
      }

      if (isAddNew == 2) {
        damageClaimSaveCustomV2();
      }
    }
  }

  function damageClaimSaveCustom() {
    setIsAnimation(true);
    let object = {} as any;

    addEditObject.moverslist = "";
    for (let i = 0; i < DamageClaimMoversList.length; i++) {
      if (DamageClaimMoversList[i].Name) {
        addEditObject.moverslist += DamageClaimMoversList[i].Name + ",";
      }
    }
    if (addEditObject.moverslist != "") {
      addEditObject.moverslist = addEditObject.moverslist.replace(/,$/, "");
    }
    object.damagedoneby = 1;
    object.name = addEditObject.name;
    object.jobid = addEditObject.jobid;
    object.servicedate = addEditObject.servicedate;
    object.claimdate = addEditObject.claimdate;
    object.description = addEditObject.description;
    // object.damagedoneby = addEditObject.damagedoneby;
    object.outcome = addEditObject.outcome;
    object.cost = isNaN(addEditObject.cost) || addEditObject.cost == "" ? 0 : addEditObject.cost;
    object.insuranceclaimref = addEditObject.insuranceclaimref;
    object.moversdata = DamageClaimMoversList;
    object.moverslist = addEditObject.moverslist;
    object.extratextfield1 = addEditObject.extratextfield1;
    object.extratextfield2 = addEditObject.extratextfield2;
    object.notifymover = addEditObject.notifymover;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVDamageClaim/MNVDamageClaimSaveCustom",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getDamageClaimGetHistoricalData();
          getDamageClaimGetJobDetailsAndMoversList(1);
          setIsAddNew(0);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function damageClaimSaveCustomV2() {
    setIsAnimation(true);
    let object = {} as any;
    object.damagedoneby = 1;
    object.name = addEditObject.name;
    object.mnvdamageclaimid = addEditObject.mnvdamageclaimid;
    object.jobid = addEditObject.jobid;
    object.servicedate = addEditObject.servicedate;
    object.moverslist = addEditObject.moverslist;
    object.claimdate = addEditObject.claimdate;
    object.description = addEditObject.description;
    // object.damagedoneby = addEditObject.damagedoneby;
    object.outcome = addEditObject.outcome;
    object.cost = Number(addEditObject.cost);
    object.insuranceclaimref = addEditObject.insuranceclaimref;
    object.extratextfield1 = addEditObject.extratextfield1;
    object.extratextfield2 = addEditObject.extratextfield2;
    object.notifymover = addEditObject.notifymover;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVDamageClaim/MNVDamageClaimSaveCustom",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data;
          getDamageClaimGetHistoricalData();
          getDamageClaimGetJobDetailsAndMoversList(1);
          setIsAddNew(0);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteDamageClaimRecord(MNVDamageClaimID: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvdamageclaimid = MNVDamageClaimID;
    axiosAuth
      .post(
        AppContext.APIURL +
        "api/MNVDamageClaim/MNVDamageClaimDeleteRecordCustom",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          getDamageClaimGetHistoricalData();
          getDamageClaimGetJobDetailsAndMoversList(1);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteDamageClaimRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  function updateSelectedPIDForParent(type: any, value: any, name: any) {
    if (type == 1) {
      addEditObject.extratextfield1 = value;
      addEditObject.extratextfield2 = name;
      setAddEditObject((prevState: any) => ({
        ...prevState,
        extratextfield1: value,
        extratextfield2: name,
      }));
    }
  }

  function getName() {
    let name = "All";
    if (addEditObject.name == "Complaint") {
      name = "Complaint For";
    } else if (addEditObject.name == "Damage Claim") {
      name = "Damage Done By";
    } else if (addEditObject.name == "Both") {
      name = "Damage Claim & Complaint For";
    }
    return name;
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}

      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {isAddNew == 0 && (
        <>
          <>
            <div className="flex-d justify-btw mb-10">
              <div className="flex-da gap-10">
                <div className="field-input">
                  <select
                    className="input-field"
                    value={damageClaimObject.name}
                    onChange={(e) =>
                      setDamageClaimObject((prevState: any) => ({
                        ...prevState,
                        name: e.target.value,
                      }))
                    }
                  >
                    <option value={"All"}>All</option>
                    <option value={"Complaint"}>Complaint</option>
                    <option value={"Damage Claim"}>Damage Claim</option>
                    <option value={"Both"}>Both</option>
                  </select>
                </div>
                {(AppContext.IsAdmin || AppContext.IsSemiAdmin) && (
                  <>
                    <div className="field-input">
                      <select
                        className="input-field"
                        value={damageClaimObject.mnvclientid}
                        onChange={(e) =>
                          setDamageClaimObject((prevState: any) => ({
                            ...prevState,
                            mnvclientid: e.target.value,
                          }))
                        }
                      >
                        <option value={0}>Select Client</option>
                        {reviewSourceTypeList &&
                          reviewSourceTypeList.map((item: any, index: any) => (
                            <React.Fragment key={index}>
                              <option value={item.PID}>{item.Name}</option>
                            </React.Fragment>
                          ))}
                      </select>
                    </div>
                    <div className="field-input">
                      <select
                        className="input-field"
                        value={damageClaimObject.mnvmoverid}
                        onChange={(e) =>
                          setDamageClaimObject((prevState: any) => ({
                            ...prevState,
                            mnvmoverid: e.target.value,
                          }))
                        }
                      >
                        <option value={0}>Select Mover</option>
                        {moversList &&
                          moversList.map((item: any, index: any) => (
                            <React.Fragment key={index}>
                              <option value={item.MNVMoverID}>
                                {item.Name}
                              </option>
                            </React.Fragment>
                          ))}
                      </select>
                    </div>
                  </>
                )}
                <div className="field-input">
                  <input
                    className="input-field"
                    placeholder="Job ID"
                    value={damageClaimObject.jobid}
                    onChange={(e) =>
                      setDamageClaimObject((prevState: any) => ({
                        ...prevState,
                        jobid: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="field-input date-field">
                  <input
                    type="date"
                    title="Service Start Date"
                    placeholder="Lag"
                    value={damageClaimObject.startdate}
                    onChange={(e) =>
                      setDamageClaimObject((prevState: any) => ({
                        ...prevState,
                        startdate: e.target.value,
                      }))
                    }
                    className="input-field"
                  />
                </div>
                <div className="field-input date-field">
                  <input
                    type="date"
                    title="Service End Date"
                    placeholder="Lag"
                    value={damageClaimObject.enddate}
                    onChange={(e) =>
                      setDamageClaimObject((prevState: any) => ({
                        ...prevState,
                        enddate: e.target.value,
                      }))
                    }
                    className="input-field"
                  />
                </div>
                <div className="flex-daj btn-start">
                  <a
                    onClick={() => getDamageClaimGetHistoricalData()}
                    className="btn-primary flex-daj"
                  >
                    Filter
                  </a>
                </div>
              </div>

              <div className="flex-daj btn-start gap-10">
                {(AppContext.IsAdmin || AppContext.IsSemiAdmin) && (
                  <>
                    <a
                      onClick={() => {
                        setAddEditObject({
                          name: "",
                          jobid: "",
                          servicedate: "",
                          claimdate: "",
                          description: "",
                          mnvclientid: 0,
                          damagedoneby: 0,
                          outcome: "",
                          cost: 0,
                          insuranceclaimref: "",
                          moverslist: "",
                          extratextfield1: "",
                          extratextfield2: "",
                          notifymover: 0,
                        });
                        setDamageClaimMoversList([]);
                        setIsAddNew(1);
                      }}
                      className="btn-primary flex-daj"
                    >
                      Add New
                    </a>
                  </>
                )}

                {(AppContext.IsAdmin || AppContext.IsSemiAdmin) && <a
                  className="btn-primary flex-daj btn-grid"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel("tblDamageClaim", "Damage Claim")
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>}
              </div>
            </div>

            <table className="reuse-table" id="tblDamageClaim">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Job ID</th>
                  <th>Client Name</th>
                  <th>Service Data</th>
                  <th>Movers</th>
                  <th>Claim Date</th>
                  <th>Description</th>
                  <th>Damage Done By</th>
                  <th>Out Come</th>
                  <th>Cost</th>
                  <th>Insurance Claim Ref</th>
                  {(AppContext.IsAdmin || AppContext.IsSemiAdmin) && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {DamageClaimGetHistoricalData &&
                  DamageClaimGetHistoricalData.map((Item: any, index: any) => (
                    <React.Fragment key={index}>
                      <tr key={index}>
                        <td>{Item.Name}</td>
                        <td>{Item.JobID}</td>
                        <td>{Item.ClientName}</td>
                        <td>{moment(Item.ServiceDate).format("DD/MM/YYYY")}</td>
                        <td>{Item.MoversList}</td>
                        <td>{moment(Item.ClaimDate).format("DD/MM/YYYY")}</td>
                        <td>{Item.Description}</td>
                        <td>{Item.DamageDoneByName}</td>
                        <td>{Item.Outcome}</td>
                        <td className="text-right">
                          £
                          {Item.Cost.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td>{Item.InsuranceClaimRef}</td>

                        {(AppContext.IsAdmin || AppContext.IsSemiAdmin) && (
                          <td className="text-center">
                            <div className="flex-daj gap-10">
                              <a
                                onClick={() => {
                                  setAddEditObject({
                                    mnvdamageclaimid: Item.MNVDamageClaimID,
                                    name: Item.Name,
                                    jobid: Item.JobID,
                                    servicedate: Item.ServiceDate,
                                    claimdate: Item.ClaimDate,
                                    description: Item.Description,
                                    damagedoneby: Item.DamageDoneBy,
                                    damagedonebyname: Item.DamageDoneByName,
                                    outcome: Item.Outcome,
                                    cost: Item.Cost,
                                    insuranceclaimref: Item.InsuranceClaimRef,
                                    moverslist: Item.MoversList,
                                    extratextfield1: Item.ExtraTextField1,
                                    extratextfield2: Item.ExtraTextField2,
                                    notifymover: 0,
                                  });
                                  setIsAddNew(2);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: Item.MNVDamageClaimID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        )}
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </>
        </>
      )}

      {isAddNew == 1 && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              {/* <div className="field-input grid-d">
                <select
                  className="input-field w-100"
                  value={addEditObject.mnvclientid}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      mnvclientid: e.target.value,
                    }))
                  }
                >
                  <option value={0}>Select Review Type</option>
                  {reviewSourceTypeList &&
                    reviewSourceTypeList.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.mnvclientid}>
                          {item.Name}
                        </option>
                      </React.Fragment>
                    ))}
                </select>
              </div> */}

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Type:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      name: e.target.value,
                    }))
                  }
                >
                  <option value={""}>Select Type</option>
                  <option value={"Complaint"}>Complaint</option>
                  <option value={"Damage Claim"}>Damage Claim</option>
                  <option value={"Both"}>Both</option>
                </select>
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Job ID:</span>
                <input
                  className="input-field w-100"
                  placeholder="Job ID"
                  title="Job ID"
                  value={addEditObject.jobid}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      jobid: e.target.value,
                    }))
                  }
                  onBlur={() => getDamageClaimGetJobDetailsAndMoversList(3)}
                />
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Service Date:
                </span>
                <input
                  disabled
                  className="input-field w-100"
                  type="date"
                  title="Service Date"
                  value={moment(addEditObject.servicedate).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      servicedate: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Claim Date:
                </span>
                <input
                  className="input-field w-100"
                  type="date"
                  title="Claim Date"
                  value={moment(addEditObject.claimdate).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      claimdate: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Description:
                </span>
                <textarea
                  className="input-field w-100"
                  placeholder="Description"
                  title="Description"
                  value={addEditObject.description}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      description: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="grid-d ">
                <span className="font-12 text-left label-color">{getName()}:</span>
                <MultiSelectionDropdown
                  listData={DamageClaimMoversList}
                  selectAllName={"All"}
                  selectFewName={getName()}
                  updateSelectedPIDForParent={updateSelectedPIDForParent}
                  type={1}
                  selectedPID={addEditObject.extratextfield1}
                ></MultiSelectionDropdown>
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Outcome:</span>
                <input
                  placeholder="Outcome"
                  title="Outcome"
                  className="input-field w-100"
                  value={addEditObject.outcome}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      outcome: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Cost:</span>
                <input
                  placeholder="Cost"
                  title="Cost"
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.cost}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      cost: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Insurance Claim Ref:
                </span>
                <input
                  placeholder="Insurance Claim Ref"
                  title="Insurance Claim Ref"
                  className="input-field w-100"
                  value={addEditObject.insuranceclaimref}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      insuranceclaimref: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Notify Mover:
                </span>
                <input
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.notifymover == 1 ? true : false}
                  onChange={(e: any) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      notifymover: e.target.checked == true ? 1 : 0,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  Save
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}

      {isAddNew == 2 && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Type:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      name: e.target.value,
                    }))
                  }
                >
                  <option value={""}>Select Type</option>
                  <option value={"Complaint"}>Complaint</option>
                  <option value={"Damage Claim"}>Damage Claim</option>
                  <option value={"Both"}>Both</option>
                </select>
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Job ID:</span>
                <input
                  disabled
                  className="input-field w-100"
                  placeholder="Job ID"
                  title="Job ID"
                  value={addEditObject.jobid}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      jobid: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Service Date:
                </span>
                <input
                  disabled
                  className="input-field w-100"
                  type="date"
                  title="Service Date"
                  value={moment(addEditObject.servicedate).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      servicedate: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Claim Date:
                </span>
                <input
                  className="input-field w-100"
                  type="date"
                  title="Claim Date"
                  value={moment(addEditObject.claimdate).format("YYYY-MM-DD")}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      claimdate: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Description:
                </span>
                <textarea
                  className="input-field w-100"
                  placeholder="Description"
                  title="Description"
                  value={addEditObject.description}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      description: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="grid-d ">
                <span className="font-12 text-left label-color">{getName()}:</span>
                <MultiSelectionDropdown
                  listData={DamageClaimMoversList}
                  selectAllName={"All"}
                  selectFewName={getName()}
                  updateSelectedPIDForParent={updateSelectedPIDForParent}
                  type={1}
                  selectedPID={addEditObject.extratextfield1}
                ></MultiSelectionDropdown>
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Outcome:</span>
                <input
                  placeholder="Outcome"
                  title="Outcome"
                  className="input-field w-100"
                  value={addEditObject.outcome}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      outcome: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">Cost:</span>
                <input
                  placeholder="Cost"
                  title="Cost"
                  className="input-field w-100"
                  type="number"
                  value={addEditObject.cost}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      cost: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Insurance Claim Ref:
                </span>
                <input
                  placeholder="Insurance Claim Ref"
                  title="Insurance Claim Ref"
                  className="input-field w-100"
                  value={addEditObject.insuranceclaimref}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      insuranceclaimref: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d">
                <span className="font-12 text-left label-color">
                  Notify Mover:
                </span>
                <input
                  placeholder="Notify Mover"
                  title="Notify Mover"
                  className="wh-auto"
                  type="checkbox"
                  checked={addEditObject.notifymover == 1 ? true : false}
                  onChange={(e: any) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      notifymover: e.target.checked == true ? 1 : 0,
                    }))
                  }
                />
              </div>
            </div>
            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => damageClaimSaveCustomV2()}
                >
                  Update
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default DamageClaims;
